import React, { Component } from 'react'
import { string, object, func } from 'prop-types'
import { Icon } from 'components'
import { DayPickerSingleDateController } from 'react-dates'
import 'react-dates/initialize'

export class McGameListDatepicker extends Component {
    static proptTypes = {
        label: string.isRequired,
        value: object,
        placeholder: string,
        onChange: func.isRequired,
    }
    static defaultProps = {
        value: null,
        placeholder: undefined,
    }

    state = {
        isFocused: false
    }

    handleFocusChange = isFocused => this.setState({ isFocused })
    handleChange = value => {
        const { onChange } = this.props
        onChange(value)
        this.handleFocusChange(false)
    }
    handleReset = () => this.handleChange(null)

    render() {
        const { label, value, placeholder } = this.props
        const { isFocused } = this.state
        const valueString = value ? value.format('DD/MM/YYYY') : ''
        return (
            <div className="McGameList-FormGroup FG-Datepicker">
                <div className="McGameList-FormGroup-Label">{label}&nbsp;</div>
                <div className="McGameList-FormGroup-InputWrapper">
                    <Icon name="calendar" />
                    <input
                        type="text"
                        value={valueString}
                        placeholder={placeholder === undefined ? label : placeholder}
                        onClick={() => this.handleFocusChange(true)}
                    />
                    <div
                        className={['McGameList-FormGroup-Cancel', { Show: !!value }]}
                        onClick={this.handleReset}
                    >
                        x
                    </div>
                </div>
                {isFocused && (
                    <DayPickerSingleDateController
                        date={value}
                        onDateChange={this.handleChange}
                        onOutsideClick={() => this.handleFocusChange(false)}
                    />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/GameList/Filters/McGameListDatepicker.js